export const sentenceCase = (string: string): string =>
  string[0].toUpperCase() + string.slice(1)

export const kebabCase = (string: string): string =>
  string
    .replace(/[^\w\s-]|_/g, '')
    .replace(/[\s-]+/g, '-')
    .toLowerCase()
